import theme from "../../Utils/theme";

const Fontstyling = {
  modalHeading: {
    textTransform: "capitalize",
    fontSize: "16px",
    fontWeight: "700",
    letterSpacing: "0.5px",
  },
  modalHeading2: {
    fontSize: "16px",
    fontWeight: "700",
    letterSpacing: "0.5px",
  },
  primary: {
    paddingLeft: "10px",
    border: "1px solid",
    borderColor: "lightGrey",
  },
  secondary: {
    paddingLeft: "10px",
    backgroud: "lightgray",
  },
  heading: {
    // textTransform: "capitalize",
    fontSize: "13.33px",
    fontWeight: "700",
    letterSpacing: "0.5px",
  },

  primaryparagraph: {
    fontSize: "12px",
    letterSpacing: "0.2px",
    fontFamily: "Arial",
    fontWeight: "500",
  },
  secondaryparagraph: {
    fontSize: "10.66px",
    letterSpacing: "0.2px",
    fontFamily: "Arial",
  },
  label: {
    fontSize: "12px",
    letterSpacing: "0.5px",
    fontFamily: "Arial",
  },
  input: {
    fontSize: "12px",
    letterSpacing: "0.5px",
    fontFamily: "Arial",
  },
  dropdown_label: {
    padding: "4.2px 10px",
    fontSize: "12px",
    letterSpacing: "0.5px",
    fontFamily: "Arial",
    paddingRight: "36px",
  },
  errorlabel: {
    fontSize: "12px",
    letterSpacing: "0.5px",
    fontFamily: "Arial",
    color: "#DC3545",
  },

  sidebarheading: {
    // textTransform: "capitalize",
    fontSize: "14px",
    fontWeight: "700",
    color: "#69666e",
    fontFamily: "Arial",
  },
  secondHeading: {
    // textTransform: "capitalize",
    fontSize: "12px",
    fontWeight: "700",
    color: "#69666e",
    fontFamily: "Arial",
  },
  savebutton: {
    background: `linear-gradient(#00aeef, #015b7c)`,
    color: "white",
    fontWeight: "700",
    fontSize: "13.33px",
    textTransform: "capitalize",
    border: "1px solid black",
    borderRadius: "8px",
    padding: "6px 28px",
    fontFamily: "Arial",
  },
  cancelbutton: {
    background: "transparent",
    color: "#0088d2",
    fontWeight: "700",
    fontSize: "13.33px",
    textTransform: "capitalize",
    border: "1px solid black",
    fontFamily: "Arial",
    borderRadius: "8px",
    padding: "6px 18px",
  },
  addnewbutton: {
    background: theme.SECONDARY_CLASSIC_DARK,
    color: "white",
    fontWeight: "700",
    fontSize: "13.33px",
    // textTransform: "capitalize",
    border: "1px solid black",
    fontFamily: "Arial",
    borderRadius: "8px",
    padding: "6px 18px",
    cursor:'pointer'
  },
  transmitbutton: {
    background: "#d9d9d9",
    color: "#0088d2",
    fontWeight: "700",
    fontSize: "13.33px",
    textTransform: "capitalize",
    border: "1px solid black",
    fontFamily: "Arial",
  },
  accordionButton : {
    background: "#000921",
    //backgroundColor:"#000921",
    color: "#0088d2",
    fontWeight: "700",
    fontSize: "13.33px",
    textTransform: "capitalize",
    border: "1px solid black",
    fontFamily: "Arial",
    borderRadius: "8px",
    padding: "6px 18px",
  },
  label_14: {
    fontSize: "14px",
    letterSpacing: "0.5px",
    fontFamily: "Arial",
  },
};
export default Fontstyling;

const home = {
  homeheading: {
    textTransform: "capitalize",
    fontSize: "24px",
    fontWeight: "700",
    letterSpacing: "0.5px",
    color: "white",
    fontFamily: "Arial",
  },
  homeprimaryparagraph: {
    textTransform: "capitalize",
    fontSize: "14.66px",
    letterSpacing: "0.5px",
    color: "white",
    fontFamily: "Arial",
  },
  homesecondaryparagraph: {
    textTransform: "capitalize",
    fontSize: "10.66px",
    letterSpacing: "0.5px",
    color: "white",
    fontFamily: "Arial",
  },
};

export const tablestyle = {
  tableheading: {
    textTransform: "capitalize",
    // fontSize: '9.33px',
    fontSize: "11px",
    fontFamily: "Arial",
    color: "white",
    fontWeight: "700",
  },
  tabledata: {
    // textTransform: "capitalize",
    // fontSize: '9.33px',
    fontSize: "11px",
    fontFamily: "Arial",
  },
};

export const clientListDrpDwnStyles = {
  control: (base) => ({
    ...Fontstyling.primaryparagraph,
    display: "flex",
    alignItems: "center",
    border: "1px solid #ced4da",
    borderRadius: "0px",
    width: "100%",
    minHeight: "28px",
    maxHeight: "28px",
    textAlign: "left",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      ...Fontstyling.primaryparagraph,
      textAlign: "left",
      backgroundColor: data.value === 0 ? "#fff" : isFocused ? "#3498ff" : null,
      color: data.value === 0 ? "#808080" : isFocused ? "white" : "#212529",
      fontSize: 12,
      paddingTop: 0,
      paddingBottom: 0,
    };
  },
};

export function isValidDate(dateString) {
  const date = new Date(dateString);
  return date instanceof Date && !isNaN(date);
}
